export const EditSpaceRepository = Symbol('EditSpaceRepository');
/**
 * Represents a service for editing a space.
 */
export const EditSpaceService = Symbol.for('EditSpaceService');
